import React from "react";
import Text from "@/components/ui/text";

interface ServiceDetailRowProps {
  label: string;
  value: string | React.ReactNode;
}

const ServiceDetailRow: React.FC<ServiceDetailRowProps> = ({
  label,
  value
}) => {
  return (
    <div className={`flex gap-8 items-center px-1 py-0 w-full`}>
      <div className="flex gap-1 items-center px-0 py-1 w-[150px]">
        <Text variant="bodySecondary">{label}</Text>
      </div>
      <div className="flex grow items-center rounded-md">
        <div className="flex grow h-full items-center px-2 py-0">
          {typeof value === "string" ? (
            <Text variant="body">{value}</Text>
          ) : (
            value
          )}
        </div>
      </div>
    </div>
  );
};

export default ServiceDetailRow;
